export default (graphComponentRef, transform, nodeFrom, nodeTo) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) || !nodeFrom || !nodeTo)
        return undefined;
    return graphComponentRef.current.graph.createEdge({
        source: nodeFrom,
        target: nodeTo,
        tag: transform
    });
};
